import {fetchSync} from '@shopify/hydrogen';
import {Product} from '@shopify/hydrogen/storefront-api-types';
import clsx from 'clsx';
import {Suspense, useEffect, useState} from 'react';
import {
  PortableTextWrapper,
  ProductCardCarousel,
  BlockServiceLift,
  BlockTeamMembers,
  BlockSectionHeader,
  BlockEmbed,
  BlockList,
  BlockSubscribe,
  BlockCaseStudyLift,
  BlockCampaignLift,
} from '~/components';
import useSanityData from '~/lib/useSanityData';
import {
  SanityHomepage,
  SanityPageType,
  SanityServicePageType,
} from '~/types/sanityTypes';

export function BlockRepeater({
  page: serverPage,
  sanityQuery,
  sanityParams,
  className,
}: {
  page: SanityPageType | SanityHomepage | SanityServicePageType;
  sanityQuery: string;
  sanityParams: {slug: string};
  className?: string;
}) {
  const styles = clsx('relative flex flex-col py-10', className);

  const page = useSanityData(serverPage, sanityQuery, sanityParams);

  const [clientLoaded, setClientLoaded] = useState(false);

  useEffect(() => {
    setClientLoaded(true);
  }, []);

  return (
    <div className={styles}>
      {page.content.map((block: any) => {
        if (block._type === 'blockPortableText') {
          return (
            <div key={block._key} className="container-narrow">
              <PortableTextWrapper blocks={block.portableText} />
            </div>
          );
        }
        if (block._type === 'blockProducts') {
          return (
            <div key={block._key} className="container">
              {clientLoaded && (
                <Suspense fallback={<p>Ladataan...</p>}>
                  <ProductCardCarouselProvider
                    title={block.title as string}
                    productIds={block.products.map(
                      (product: any) => product.store.id,
                    )}
                  />
                </Suspense>
              )}
            </div>
          );
        }
        if (block._type === 'blockServiceLift') {
          return <BlockServiceLift key={block._key} blockContent={block} />;
        }
        if (block._type === 'blockCaseStudyLift') {
          return <BlockCaseStudyLift key={block._key} blockContent={block} />;
        }
        if (block._type === 'blockTeamMembers') {
          return <BlockTeamMembers key={block._key} blockContent={block} />;
        }
        if (block._type === 'blockSectionHeader') {
          return <BlockSectionHeader key={block._key} blockContent={block} />;
        }
        if (block._type === 'blockEmbed') {
          return <BlockEmbed key={block._key} blockContent={block} />;
        }
        if (block._type === 'blockList') {
          return <BlockList key={block._key} blockContent={block} />;
        }
        if (block._type === 'blockNewsLetter') {
          return <BlockSubscribe key={block._key} blockContent={block} />;
        }
        if (block._type === 'blockCampaignLift') {
          return <BlockCampaignLift key={block._key} blockContent={block} />;
        }
      })}
    </div>
  );
}

function ProductCardCarouselProvider({
  title,
  productIds,
}: {
  title: string;
  productIds: string[];
}) {
  let products: Product[] = [];

  const response = fetchSync(
    '/api/getShopifyProductsByIds?ids=' + productIds.join(','),
  );

  if (!response.ok) {
    console.log('Could not get Shopify products');
    return null;
  }

  products = response.json();

  return products && <ProductCardCarousel title={title} products={products} />;
}
